<template>
  <div>
    <v-container fluid :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#cdd5df' }">
      <v-container class="contain-width">
        <v-row>
          <v-col
              cols="12"
              xs="12"
              sm="12"
              md="8"
              offset-md="2"
          >
            <h1 class="text-h3 black--text mb-6">{{ $t('headings.Frequently asked questions') }}</h1>
        <v-row>
          <v-col cols="12" class="col-xs-12" sm="12" md="4" lg="3">
            <v-card flat class="filter-card">
              <v-card-title>{{ $t('Filter by') }}</v-card-title>
              <v-card-text>
                <v-switch v-model="filterIndividuals" :label="$t('labels.Member')"></v-switch>
                <v-switch v-model="filterOrganisations" :label="$t('labels.Partner')"></v-switch>
                <v-switch v-model="filterSuperPartner" :label="$t('labels.Super partner')"></v-switch>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="col-xs-12" sm="12" md="8" lg="9">
            <div v-if="loading" class="d-flex justify-center mt-16">
              <v-icon>mdi mdi-36px mdi-spin mdi-loading</v-icon>
            </div>
            <p v-else-if="faqs.length === 0" class="text-body-1">{{ $t('Sorry there are no FAQs found') }}.</p>
            <v-expansion-panels v-else flat focusable v-model="openedPanel">
              <v-expansion-panel
                  v-for="(faq,i) in faqs"
                  :key="i"
                  :id="'faq' + i++"
                  class="mb-4"
                  style="border-radius: 10px !important;border-color: blue"
              >
                <v-expansion-panel-header>
                  {{ faq.question }}
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-6">
                  <div v-html="faq.answer"></div>
                  <vimeo-player v-if="faq.video_id" ref="player" :video-id="faq.video_id" @ready="onReady" class="player-container mt-6" :options="options"></vimeo-player>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Footer from "./Footer.vue";
import {i18n} from "../i18n";
import {mapState} from "vuex";

export default {
  name: "Faqs",
  metaInfo () {
    return {
      title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Frequently asked questions'),
      htmlAttrs: {
        lang: i18n.locale
      },
      meta: [
        {name: 'description', content: i18n.t('Find answers to commonly asked questions')}
      ]
    }
  },
  components: {
    'Footer': Footer
  },
  data () {
    return {
      openedPanel: null,
      faqs: [],
      filterIndividuals: false,
      filterOrganisations: false,
      filterSuperPartner: false,
      options: {'responsive': true, 'dnt': true},
      playerReady: false,
      loading: true
    }
  },
  mounted () {

    window.scrollTo(0,0);

    this.loadFaqs()

  },
  computed: {
    ...mapState({
      brand: state => state.brand,
brandName: state => state.brandName
    }),
  },
  watch: {
    '$i18n.locale': function() {
      window.location.hash = ''
      window.scrollTo(0,0);
      this.loadFaqs()
    },
    filterIndividuals(val) {
      if (val) {

        this.filterOrganisations = false
        this.filterSuperPartner = false

        this.faqs = []
        this.loading = true

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
          headers: {'Accept-Language': i18n.locale},
        });

        instance
            .get('/api/faqs?tag=member')
            .then(response => {
              this.faqs = response.data.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              window.prerenderReady = true;
            })
      }
      else if(!this.filterOrganisations && !this.filterSuperPartner && !this.filterIndividuals) {

        this.faqs = []
        this.loading = true

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
          headers: {'Accept-Language': i18n.locale},
        });

        instance
            .get('/api/faqs')
            .then(response => {
              this.faqs = response.data.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    filterOrganisations(val) {
      if (val) {

        this.filterIndividuals = false
        this.filterSuperPartner = false

        this.faqs = []
        this.loading = true

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
          headers: {'Accept-Language': i18n.locale},
        });

        instance
            .get('/api/faqs?tag=partner')
            .then(response => {
              this.faqs = response.data.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              window.prerenderReady = true;
            })
      }
      else if(!this.filterOrganisations && !this.filterSuperPartner && !this.filterIndividuals) {

        this.faqs = []
        this.loading = true

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
          headers: {'Accept-Language': i18n.locale},
        });

        instance
            .get('/api/faqs')
            .then(response => {
              this.faqs = response.data.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    filterSuperPartner(val) {
      if (val) {

        this.filterIndividuals = false
        this.filterOrganisations = false

        this.faqs = []
        this.loading = true

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
          headers: {'Accept-Language': i18n.locale},
        });

        instance
            .get('/api/faqs?tag=super')
            .then(response => {
              this.faqs = response.data.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              window.prerenderReady = true;
            })
      }
      else if(!this.filterOrganisations && !this.filterSuperPartner && !this.filterIndividuals) {

        this.faqs = []
        this.loading = true

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
          headers: {'Accept-Language': i18n.locale},
        });

        instance
            .get('/api/faqs')
            .then(response => {
              this.faqs = response.data.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    openedPanel(val) {
      if (val !== undefined && val !== null) {

        window.scrollTo(0,0);

        let faqNumber = parseInt(val)+1
        window.location.hash = 'faq' + faqNumber

        let hash = 'faq' + val
        console.log(hash)

        setTimeout(function() {
          let target = document.querySelector('#' + hash);
          console.log(target.offsetTop)
          document.getElementById("scrolling-content").scrollTop = target.offsetTop +120
        }, 1000);



      }
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    loadFaqs() {
      const instance = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
      });

      instance
          .get('/api/faqs')
          .then(response => {
            this.faqs = response.data.data
            this.loading = false
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            window.prerenderReady = true;



            this.openedPanel = null

            let faq = window.location.hash
            if (faq.length > 1) {
              let target = document.querySelector(faq);
              console.log(target.offsetTop)
              console.log(target.offsetTop + 120)

              document.getElementById("scrolling-content").scrollTop = target.offsetTop + 120

              let opened = parseInt(faq.substring(4)) -1
              this.openedPanel = opened;
            }

          })
    },
    navigate(routeName) {
      this.$router.push({name: routeName})
    },
    onReady() {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    stop () {
      this.$refs.player.stop()
    },
  }
}
</script>

<style scoped>
  .filter-card {
    border-radius: 10px;
    border: none !important;
  }

  .v-expansion-panel-header--active {
    background-color: var(--v-primary-base);
    opacity: 1;
    color: var(--v-textOnPrimary-base);
  }
</style>

<style>
  .v-application .v-expansion-panel-header--active .v-icon, .v-application .v-expansion-panel-header--active .primary--text {
    color: white !important;
  }
  .v-expansion-panel-content p, .v-expansion-panel-content li {
    font-size: 1rem!important;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: .03125em!important;
    font-family: Roboto,sans-serif!important;
  }
  .v-expansion-panel-content ul, .faq ol {
    margin-bottom: 16px;
  }
  .v-expansion-panel-content p {
    margin-bottom: 0;
  }
</style>
